<template lang="pug">
  div.fill-height
    v-layout.align-center.justify-end
      v-dialog(width="30%" persistent v-model="addContactDialog")
        v-btn.primary.mr-3(fab small slot="activator" data-test="create-contact-open")
          v-icon(medium) add
        v-card
          v-card-title.white--text.title.primary.elevation-4
            v-layout.justify-center.align-center
              v-flex.xs10.offset-xs1.text-xs-center CRÉER UN CONTACT
              v-flex.xs1.text-xs-right
                v-icon(large dark @click="addContactDialog = false") close
          v-card-text.pa-0
            rc-user-contact(
              :parentId="clientId"
              context="add"
              @mounted="$store.dispatch('contacts/')"
              @close="addContactDialog = false"
              @created="createdContact"
            )
    v-layout.client-contacts(v-if="contacts.length || !loaded" v-rc-loader="!loaded" style="height: calc(100% - 52px);")
      v-flex.xs8.lg8.scroll-y-overflow.elevation-1.align-self-start.fill-height
        v-list.py-0(two-line)
          .contact-tile.click(
            v-for="contact in contacts"
            :key="contact.id"
            @click="selectedContact = contact"
            @dblclick="$router.push({ name: 'client_contact_detail', params: { contactId: contact.id } })"
            :class="{ 'selected-contact': selectedContact && selectedContact.id === contact.id}"
            )
              v-layout.pt-2.pb-1
                v-avatar.mx-3(size="60" style="filter: grayscale(100%);")
                  v-img(alt="avatar" :src="`/v2/erp/ambassador/contacts/${contact.id}/image/medium?t=${contact.write_date}`" v-if="contact.has_image")
                  v-icon(size="60" v-else color="grey lighten-1") account_circle
                v-layout.column
                  v-layout
                    span.subheading {{ contact.first_name }} {{ contact.last_name }}
                  v-layout.justify-space-between
                    .body-1.grey--text.text--darken-1 {{ contact.email }}
                  v-layout.pt-2.wrap
                    v-chip.mt-0.mb-2(v-for="type in getContactTypeNames(contact.type_ids)" :key="type" small) {{ type }}
      v-flex.xs4.lg4.scroll-y-overflow.elevation-1.align-self-start.fill-height(v-if="selectedContact")
        v-layout.wrap.fill-height.align-content-space-between
          div(style="width: 100%")
            v-flex.xs12
              rc-user-contact(
                :contact="selectedContact"
                :contactList="true"
                @edited="editSelectedContact"
                @deleteAvatar="getContacts"
                @postAvatar="getContacts"
              )
              //- v-layout.align-center.justify-space-between
                div.contact-name-details
                  v-text-field(
                    label="Prénom"
                    :value="selectedContact.first_name || '-'"
                    readonly
                  )
                  v-text-field(
                    label="Nom"
                    :value="selectedContact.last_name || '-'"
                    readonly
                  )
                  //- v-text-field(
                    label="Poste"
                    :value="selectedContact.function || '-'"
                    readonly
                    )
                  //- div.mt-2(v-if="selectedContact.functions.length")
                  div.pt-2.caption.theme--light.v-label(v-if="getContactTypeNames(selectedContact.type_ids).length") Type de contact
                  div.subheading {{ getContactTypeNames(selectedContact.type_ids) }}
                v-avatar(size="80" style="filter: grayscale(100%);")
                  v-img(alt="avatar" :src="`/v2/erp/ambassador/contacts/${selectedContact.id}/image/medium?t=${selectedContact.write_date}`" v-if="selectedContact.has_image")
                  v-icon(size="80" v-else color="grey lighten-1") account_circle
            v-flex.xs12.pt-1(v-if="$store.state.app.destination.id === 1 && selectedContact.user && selectedContact.user.has_password")
              v-chip(v-for="product in selectedContact.contact_products.filter(x => x.length)" :key="product")
                span {{ product }}
                v-icon.ml-2(small v-if="selectedContact.referent_products.includes(product)") record_voice_over
            v-flex.xs12.pt-3(v-if="$store.state.app.destination.id === 1")
              span.label.grey--text.text--darken-2 Accès STUDIO : 
              span.error--text.pl-2(v-if="!selectedContact.user") Non
              span.success--text.pl-2(v-else-if="selectedContact.user.has_password") Oui
              span.warning--text.pl-2(v-else) En cours d'activation
          v-flex.xs12.pt-3
            v-layout.justify-end
              v-btn.mb-3.mr-3(color="primary" @click="$router.push({ name: 'client_contact_detail', params: { contactId: selectedContact.id } })") Accéder aux détails du contact
    v-layout.justify-center.pt-5(v-else)
      .subheading.font-italic.grey--text.text--darken-2 Il n'y a aucun contact rattaché à ce compte.
</template>

<script>
import RcUserContact from '@/components/RcUserContact/RcUserContact.vue';
import RcFilterTable from '@/components/RcTable/RcTable.vue';
import apiContactService from '@/services/api/ambassador/contactService';

export default {
  components: {
    RcUserContact,
    RcFilterTable,
  },
  data() {
    return {
      contacts: [],
      addContactDialog: false,
      loaded: false,
      clientId: this.$route.params.clientId,
      size: 100,
      selectedContact: null,
      headers: [
        {
          label: '',
          type: 'avatar',
          column: 'image_url',
          width: '90px',
          padding: 'left',
        },
        {
          label: 'Nom',
          // sortable: true,
          column: 'last_name',
          filters: {
            type: 'text',
            operands: ['ilike'],
          },
          width: '12%',
        },
        {
          label: 'Prenom',
          // sortable: true,
          column: 'first_name',
          filters: {
            type: 'text',
            operands: ['ilike'],
          },
          width: '12%',
        },
        {
          label: 'Login',
          // sortable: true,
          column: 'user.login',
          filters: {
            values: [
              { label: 'Tous les utilisateurs', value: '' },
              { label: 'Avec un accès STUDIO', value: 'is not null' },
              { label: 'Sans accès STUDIO', value: 'is null' },
            ],
            default: { label: 'Tous les utilisateurs', value: '' },
            operands: [],
            customOperand: true,
            type: 'select',
            field: 'ru.partner_id'
          },
          width: '16%',
        },
        {
          label: 'Email',
          // sortable: true,
          column: 'email',
          filters: {
            type: 'text',
            operands: ['ilike'],
          },
          width: '16%',
        },
        {
          label: 'Téléphone',
          // sortable: true,
          column: 'phone',
          filters: {
            type: 'text',
            operands: ['ilike_remove_space_and_point'],
          },
          width: '14%',
        },
        {
          label: 'Produits',
          type: 'product_groups',
          sortable: false,
          column: 'contact_products',
          width: '16%',
        },
        {
          label: 'Accès STUDIO',
          type: 'access',
          sortable: false,
          column: 'user',
          align: 'center',
          center: true,
          width: '10%',
        },
      ],
    };
  },
  mounted() {
    this.$store.dispatch('contacts/setSelected', { country_id: 76, gender: 'm' });
    this.getContacts();
  },
  methods: {
    editSelectedContact({ field, value }) {
      this.selectedContact[field] = value;
      apiContactService.put(this.selectedContact.id, this.selectedContact);
    },
    getContactTypeNames(typeIds) {
      return typeIds.map(it => this.$store.state.contacts.types.find(x => x.id === it) || {}).map(it => it.display_name);
    },
    async getContacts() {
      const selectedId = this.selectedContact?.id || null;
      const contactsResponse = await apiContactService.getByClientId(this.clientId);
      this.contacts = contactsResponse.data;
      if (selectedId) {
        this.selectedContact = this.contacts.find(it => it.id === selectedId) || this.contacts[0];
      } else {
        this.selectedContact = this.contacts[0];
      }
      this.loaded = true;
    },
    createdContact() {
      this.getContacts();
    },
  },
};
</script>

<style lang="scss">
  .products-list {
    list-style-type: none;
  }
  .contact-tile:not(.selected-contact) {
    &:hover {
      background-color: #eee;
    }
      border-bottom: 1px solid lightgrey;
    transition: none;
    color: black;
  }
  .selected-contact {
    background-color: var(--primary);
    color: white;
    .body-1 {
      color: white!important;
    }
    .v-list__tile__title {
      color: white!important;
    }
    transition: none;
  }
  .client-contacts {
    .table-header {
      font-size: 16px!important;
    }
  }
  .contact-name-details {
    .v-text-field__details {
      margin: 0;
    }
    .v-text-field:not(.error--text) {
      .v-text-field__details {
        display: none;
      }
      .v-input__slot {
        margin: 0;
      }
    }
    .detail {
      .v-input.v-select {
        padding-top: 0px;
        .v-input__control {
          padding-left: 10px;
        }
      }
    }
    .v-input__slot::after {
      content: none!important;
    }
    .v-input__slot::before {
      content: none!important;
    }
    .v-text-field.v-text-field--full-width .v-input__control {
      padding-bottom: 5px;
    }
    .v-text-field.v-text-field--full-width .v-input__control {
      padding: 0px;
    }
  }
</style>
